
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","data-name":"Слой 1","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M125 41.91a9.37 9.37 0 00-9-8.91H67.91a11.27 11.27 0 00-22.19 0H35a8 8 0 00-7.33 4.16L11.5 66.67 8.16 69a7.42 7.42 0 00-3.07 4.76l-5 27.15a6.63 6.63 0 001.52 5.45A7.1 7.1 0 007 109h10.25a14.67 14.67 0 0029 0h37a14.67 14.67 0 0029 0H126a2 2 0 001.45-.62 2 2 0 00.55-1.47zM56.82 27.72a7.29 7.29 0 017 5.28h-14a7.3 7.3 0 017-5.28zM25.19 50h22.37l-3.2 16H16.43zm6.55 67.35a10.7 10.7 0 1110.69-10.7 10.71 10.71 0 01-10.69 10.7zm65.91 0a10.7 10.7 0 1110.7-10.7 10.71 10.71 0 01-10.7 10.7zm14.6-12.35a14.69 14.69 0 00-29.19 0H46.33a14.69 14.69 0 00-29.19 0H7a3.14 3.14 0 01-2.28-1.2 2.69 2.69 0 01-.72-2.17l5-27.15a3.43 3.43 0 011.42-2.21l3.3-2.27H46a2 2 0 002-1.61l4-20a2 2 0 00-.41-1.66A2 2 0 0050 46H27.38l3.79-6.92A4 4 0 0135 37h81a5.41 5.41 0 015 5.09l2.91 62.91z"}}),_c('path',{attrs:{"d":"M105 56h-9v-9a4.09 4.09 0 00-4.25-4h-9.5A4.09 4.09 0 0078 47v9h-9a4.09 4.09 0 00-4 4.25v9.5A4.09 4.09 0 0069 74h9v9a4.09 4.09 0 004.25 4h9.5A4.09 4.09 0 0096 83v-9h9a4.09 4.09 0 004-4.25v-9.5a4.09 4.09 0 00-4-4.25zm0 13.75V70H94a2 2 0 00-2 2v10.92a.48.48 0 01-.28.08H82V72a2 2 0 00-2-2H69.08a.48.48 0 01-.08-.28v-9.5-.25h11a2 2 0 002-2V47.05a.48.48 0 01.28-.08h9.75V58a2 2 0 002 2h10.94a.48.48 0 01.06.25zM45.64 20.14a2 2 0 001.41.59 2 2 0 001.42-.59 2 2 0 000-2.82L44 12.89a2 2 0 10-2.83 2.83zm20.94.59a2 2 0 001.42-.59l4.43-4.42a2 2 0 00-2.82-2.83l-4.43 4.43a2 2 0 001.41 3.41zm-9.76-3.47a2 2 0 002-2V9a2 2 0 10-4 0v6.26a2 2 0 002 2z"}})])
          )
        }
      }
    